module.exports = __webpack_public_path__ + "static/media/forward.d29460d1.png";